<div id="splash-screen" class="splash-screen">
  <app-brand-logo size="lg"></app-brand-logo>
  <span>Loading ...</span>
</div>

<router-outlet></router-outlet>

<screen-size-detector></screen-size-detector>
